import arrow from '../../static/icons/arrow.svg'

function ConditionsSummary(props) {
    const { waveDir, waveHeight, wavePeriod, windDir, windSpd } = props.summary;

    const rotateArrow = (angle) => {
        return {transform: `rotate(${angle + 180}deg)`};
    }

    // DOM Render =====================================================================================
    return(
        <div className="text-left flex flex-wrap justify-around">
            <div className={`m-2 md:m-8 my-8 flex justify-between items-center ${waveDir ? '' : 'hidden'}`}>
                <object data={arrow} aria-label="arrow icon" style={rotateArrow(waveDir)} className="arrow-icon" />

                <div className='ml-8'>
                    { waveHeight === null ? '' : <p className='text-xs sm:text-base'><b>Mean Wave Height: </b>{waveHeight} ft</p> }
                    { waveDir === null ? '' : <p className='text-xs sm:text-base'><b>Mean Wave Direction: </b>{waveDir} deg</p> }
                    { wavePeriod === null ? '' : <p className='text-xs sm:text-base'><b>Mean Wave Period: </b> {wavePeriod} sec</p>}
                </div>
            </div>
            
            <div className={`sm:m-2 md:m-8 flex justify-between items-center ${windDir ? '' : 'hidden'}`}>
                <object data={arrow} aria-label="arrow icon" style={rotateArrow(windDir)} className="arrow-icon" />

                <div className='ml-8'>   
                    { windDir === null ? '' : <p className='text-xs sm:text-base'><b>Mean Wind Direction: </b> {windDir} deg</p>}
                    { windSpd === null ? '' : <p className='text-xs sm:text-base'><b>Mean Wind Speed: </b> {windSpd} knot(s)</p>}
                </div>
            </div>
        </div>
    )
}

export default ConditionsSummary;